import { render, staticRenderFns } from "./DarkToggler.vue?vue&type=template&id=081b1a0a&scoped=true&"
import script from "./DarkToggler.vue?vue&type=script&lang=js&"
export * from "./DarkToggler.vue?vue&type=script&lang=js&"
import style0 from "./DarkToggler.vue?vue&type=style&index=0&id=081b1a0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081b1a0a",
  null
  
)

export default component.exports